module.exports = __webpack_public_path__ + "static/media/underground_path.9a3f546f.svg";